import { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import LoadingButton from 'components/loading_button/loading_button';

const Buttons = ({ section }) => {
  const { isValid, isSubmitting } = useFormikContext();
  const history = useHistory();
  const closeOffcanvasRef = useRef(
    document.querySelector(
      '#experience-off-canvas [data-bs-dismiss="offcanvas"]'
    )
  );
  const isEvent = section === 'events';
  const buttonText = isEvent ? 'Add to booking' : 'Book now';
  const handleBackButtonClick = () => {
    const { length } = history;
    if (length > 1) {
      return history.push('/');
    }
    closeOffcanvasRef.current?.click();
  };

  return (
    <div className="py-4 border-top">
      <div className="d-flex">
        <button
          type="button"
          onClick={handleBackButtonClick}
          className="experience-booking__back-btn btn btn-outline-grey w-auto me-2"
        >
          Back
        </button>

        <LoadingButton
          type="submit"
          className="btn btn-primary w-100 text-white"
          disabled={isSubmitting || !isValid}
          loading={isSubmitting}
          data-ga-event="add_experience_to_booking"
        >
          {isSubmitting ? 'Confirming Booking...' : buttonText}
        </LoadingButton>
      </div>
    </div>
  );
};

Buttons.propTypes = {
  section: PropTypes.oneOf(['events', 'experiences', 'pages']),
};

export default Buttons;
